import React from 'react';
import { Box, styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';

import { LoginContainer } from '@paragon/login-tools';
import { Notifier, NotifierDialog } from '@paragon/notification-tools';

import { startApp } from '../actions/startAppActions';
import AvailableTemplatesDrawer from './AnnotationTools/AvailableTemplatesDrawer';
import DrawingCanvas from './DrawingCanvas/DrawingCanvas';
import Header from './Header/Header';
import { useAppDispatch } from './hooks';
import KeyboardInputListener from './KeyboardInputListener';
import LeftSidebar from './LeftSidebar';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent': { color: 'white', marginLeft: 390 },
}));

export default function PdfReviewClient() {
  const dispatch = useAppDispatch();

  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      maxSnack={3}
      Components={{
        default: StyledMaterialDesignContent,
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
      }}
    >
      <Box sx={{ flexGrow: 1, height: '100vh', zIndex: 1, overflow: 'hidden', position: 'relative', display: 'flex' }}>
        <LoginContainer
          requirePermission="markup-access"
          onLogIn={async () => {
            await dispatch(startApp());
          }}
        >
          <Header />
          <Notifier />
          <NotifierDialog />
          <KeyboardInputListener />
          <LeftSidebar />
          <DrawingCanvas />
          <AvailableTemplatesDrawer />
        </LoginContainer>
      </Box>
    </SnackbarProvider>
  );
}
